import { useEffect, useState } from 'react';
import React from 'react';
import './donde.css';
import { useTranslation } from "react-i18next";

import librito from '../../../assets/imgs/libro_bitcoin/Rectangle_libro2.png';
import logo1 from '../../../assets/imgs/libro_bitcoin/LOGO_EDITORIAL_2.png';
import logo2 from '../../../assets/imgs/libro_bitcoin/Assets_Elektra-blanco.svg';
import logoAmazon from '../../../assets/imgs/libro_bitcoin/logo-amazon-white2.svg';
import logoShopBaz from '../../../assets/imgs/libro_bitcoin/shopinbaz2.svg';
import logoPorrua from '../../../assets/imgs/libro_bitcoin/porrua_white.svg';
import logoGandhi from '../../../assets/imgs/libro_bitcoin/logo-gandhi-white.svg';
import librito2 from '../../../assets/imgs/libro_bitcoin/Bitcoin-imgbook2.png';
import logoKindle from '../../../assets/imgs/libro_bitcoin/kindle-white.svg';
import logoGPlay from '../../../assets/imgs/libro_bitcoin/googleplay-white.svg';
import logoKobo from '../../../assets/imgs/libro_bitcoin/kobo-white.svg';

import logoAudible from '../../../assets/imgs/libro_bitcoin/Audible_Logo_BW_Negative_RGB.png';
import logoApple from '../../../assets/imgs/libro_bitcoin/ES_Apple_Books_Get_Solid_wht_RGB_080423.svg';

const Donde = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [isFromMexico, setIsFromMexico] = useState(null);

    const URLS_MX = {
        porrua: 'https://porrua.mx/la-iluminacion-de-bitcoin-9781967693047.html',
        amazon: 'https://www.amazon.com.mx/ILUMINACIÓN-BITCOIN-OSCURA-DINERO-Spanish/dp/1967693048/ref=tmm_hrd_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.oEvBvIrUdeO5BpgY00JMZWYZUDgBVLBWSCvXo6r1F12H59tlebYOm45rSlT5y8-tVBUmR9J3c81EamxTNeoRch7HDsclwLiUIPJFy5Z0uwqCglO7T243bgC2kdUIHjBMFjk3VIGr9BiZW1JComMPYA8VDL2mDhhtZ6jnGrah8Oeofk5TituNYbrhub6Ll_JvhdumotMnY53_hlit03ZIl7_UD4KrduXCCQio8f9OC8LcZNTxhk4_6lEit5sRh2-6neV7kCJ_zNyo964ZOeX6gQ.DBaUMyz5dHMLmqMyhPslEPLBc9aymsNM25bXqAPFqK4&qid=1753227141&sr=8-1',
        elektra: 'https://www.elektra.mx/la-iluminacion-de-bitcoin-el-final-de-la-edad-oscura-del-dinero-fiat-1300812537/p',
        bancoazteca: 'https://bancoazteca.onelink.me/cRsP/df8aphxl',
        gandhi: 'https://www.gandhi.com.mx/la-iluminacion-de-bitcoin-9781967693047/p',
        audible: 'https://www.audible.com/es_US/pd/La-iluminacion-de-bitcoin-Audiolibro/B0FFJSGKPC',
        gplay: 'https://play.google.com/store/audiobooks/details/Ricardo_B_Salinas_LA_ILUMINACI%C3%93N_DE_BITCOIN?id=AQAAAEDKmV7ZhM&pli=1',
        kobo: 'https://www.kobo.com/mx/es/audiobook/la-iluminacion-de-bitcoin?sId=0cb0bbed-5f3e-47ce-82a9-f33570d43baf',
        kindle: 'https://www.amazon.com.mx/ILUMINACI%C3%93N-BITCOIN-FINAL-OSCURA-DINERO-ebook/dp/B0DF5XZXP4',
    };


    const compraInternacional = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        });
    };

    const compraMexico = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Mexico',
            value: 1
        });
    };

    const IMGcompraInternacional = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        })
        window.open('https://thesaifhouse.com/');
    };

    const IMGcompraInternacionalEbook = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        })
        window.open('https://books.apple.com/us/book/the-bitcoin-enlightenment/id6747117918');
    };

    const IMGcompraInternacionalAudiobook = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Internacional',
            value: 1
        })
        window.open('https://www.audible.com/es_US/pd/The-Bitcoin-Enlightenment-Audiolibro/B0FBYMXMR6');
    };

    const IMGcompraMexico = () => {
        window.gtag('event', 'click', {
            event_category: 'Interacción',
            event_label: 'compra Mexico',
            value: 1
        })
        window.open('https://www.elektra.mx/the-bitcoin-enlightenment-1300708842/p');
    };

    const compraMX = (store) => {
        window.gtag?.('event', 'click', {
            event_category: 'Interacción',
            event_label: `compra Mexico - ${store}`,
            value: 1,
        });

        const url = URLS_MX[store];
        if (!url) {
            console.warn(`Store "${store}" no reconocida`);
            return;
        }

        window.open(url, '_blank', 'noopener,noreferrer');
    };

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(data => {
                console.log("Mexico");
                setIsFromMexico(data.country_code === 'MX');
            })
            .catch(err => {
                console.error('Error detecting country:', err);
                setIsFromMexico(true);
            });
    }, []);

    return (
        <>
            <div class="landing_bitcoin_donde">
                <div class="landing_bitcoin_donde_adquierelo">
                    <div class="landing_bitcoin_donde_adquierelo_content">
                        <div class="adquierelo_content_1">
                            <h3>{(t('donde.titulo'))}</h3>
                            {/* <div class="adquierelo_content_3 adquierelo_content_4">
                                <img src={librito2}></img>
                            </div>
                            {isFromMexico ? (
                                    <>*/}
                            {t('donde.btnaudio') === 'ES' && (
                                <>
                                    <div className='div-opciones-buy-b hr-donde-bit-cut'>

                                        <div className='div-2'>
                                            <img onClick={() => compraMX('gandhi')} src={logoGandhi}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://www.gandhi.com.mx/la-iluminacion-de-bitcoin-9781967693047/p'>{(t('donde.btn1'))}</a>
                                        </div>

                                        <div className='div-2'>
                                            <img onClick={() => compraMX('amazon')} src={logoAmazon}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://www.amazon.com.mx/ILUMINACI%C3%93N-BITCOIN-OSCURA-DINERO-Spanish/dp/1967693048/ref=tmm_hrd_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.oEvBvIrUdeO5BpgY00JMZWYZUDgBVLBWSCvXo6r1F12H59tlebYOm45rSlT5y8-tVBUmR9J3c81EamxTNeoRch7HDsclwLiUIPJFy5Z0uwqCglO7T243bgC2kdUIHjBMFjk3VIGr9BiZW1JComMPYA8VDL2mDhhtZ6jnGrah8Oeofk5TituNYbrhub6Ll_JvhdumotMnY53_hlit03ZIl7_UD4KrduXCCQio8f9OC8LcZNTxhk4_6lEit5sRh2-6neV7kCJ_zNyo964ZOeX6gQ.DBaUMyz5dHMLmqMyhPslEPLBc9aymsNM25bXqAPFqK4&qid=1753227141&sr=8-1'>{(t('donde.btn1'))}</a>
                                        </div>
                                        <div className='div-2'>
                                            <img onClick={() => compraMX('porrua')} src={logoPorrua}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://porrua.mx/la-iluminacion-de-bitcoin-9781967693047.html'>{(t('donde.btn1'))}</a>
                                        </div>


                                        <div className='div-2'>
                                            <img onClick={() => compraMX('elektra')} src={logo2}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://www.elektra.mx/la-iluminacion-de-bitcoin-el-final-de-la-edad-oscura-del-dinero-fiat-1300812537/p'>{(t('donde.btn1'))}</a>
                                        </div>
                                        <div className='div-2'>
                                            <img onClick={() => compraMX('bancoazteca')} style={{ paddingTop: '10%', paddingBottom: '10%' }} src={logoShopBaz}></img>
                                            <a onClick={compraMexico} target='_blank' href='https://bancoazteca.onelink.me/cRsP/df8aphxl'>{(t('donde.btn1'))}</a>
                                        </div>
                                    </div>
                                    <div className='div-opciones-buy-b-2'>
                                        <div className='div-opciones-buy-b-2-1'>
                                            <h4>AUDIOLIBRO</h4>
                                            <div className='div-opciones-buy-b'>
                                                <div className='div-2'>
                                                    <img style={{ paddingTop: '10%', paddingBottom: '10%' }} onClick={() => compraMX('audible')} src={logoAudible}></img>
                                                </div>
                                                <div className='div-2 div-2-img-big'>
                                                    <img onClick={() => compraMX('gplay')} src={logoGPlay}></img>
                                                </div>
                                                <div className='div-2'>
                                                    <img onClick={() => compraMX('kobo')} src={logoKobo}></img>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='div-opciones-buy-b-2-3'>
                                            <h4>EBOOK</h4>
                                            <div className='div-opciones-buy-b'>
                                                <div className='div-2'>
                                                    <img onClick={() => compraMX('kindle')} src={logoKindle}></img>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )}
                            {t('donde.btnaudio') === 'EN' && (
                                <>
                                    <div className='div-opciones-buy-b'>
                                        <div className='div-2'>
                                            <img onClick={IMGcompraMexico} src={logo2}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://www.elektra.mx/the-bitcoin-enlightenment-1300708842/p'>{(t('header.btn1'))}</a>

                                        </div>

                                        <div className='div-2'>
                                            <img style={{ paddingTop: '10%', paddingBottom: '10%' }} onClick={IMGcompraInternacionalAudiobook} src={logoAudible}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://www.audible.com/es_US/pd/The-Bitcoin-Enlightenment-Audiolibro/B0FBYMXMR6'>Buy Audiobook</a>
                                        </div>
                                        <div className='div-1'>
                                            <img style={{ paddingTop: '10%', paddingBottom: '10%' }} onClick={IMGcompraInternacionalEbook} src={logoApple}></img>
                                            <a onClick={compraInternacional} className='a-bit-opt' target='_blank' href='https://books.apple.com/us/book/the-bitcoin-enlightenment/id6747117918'>Buy Ebook</a>
                                            <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://books.apple.com/us/audiobook/the-bitcoin-enlightenment-ending-the-fiat-dark-age/id1817382846'>
                                                Buy Audiobook
                                            </a>
                                        </div>

                                        <div className='div-1'>
                                            <img onClick={IMGcompraInternacional} src={logo1}></img>
                                            <a onClick={compraInternacional} className='a-bit-opt' target='_blank' href='https://thesaifhouse.com/'>{(t('header.btn2'))}</a>
                                            <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-digital-book/?v=3d26b0b17065'>{(t('header.btn3'))}</a>

                                            {t('donde.btnaudio') === 'EN' && (
                                                <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-audiobook/?v=0b3b97fa6688'>
                                                    Buy Audiobook
                                                </a>
                                            )}
                                        </div>


                                    </div>
                                </>
                            )}
                            {/* 
                                </>
                            ) : (
                                <>
                                    <div className='div-opciones-buy-b'>
                                        <div className='div-2'>
                                            <img onClick={IMGcompraMexico} src={logo2}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://www.elektra.mx/the-bitcoin-enlightenment/p'>{(t('header.btn1'))}</a>
                                        </div>

                                        <div className='div-2'>
                                            <img style={{ paddingTop: '10%', paddingBottom: '10%' }} onClick={IMGcompraInternacionalAudiobook} src={logoAudible}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://www.audible.com/es_US/pd/The-Bitcoin-Enlightenment-Audiolibro/B0FBYMXMR6'>Buy Audiobook</a>
                                        </div>
                                        <div className='div-2'>
                                            <img style={{ paddingTop: '10%', paddingBottom: '10%' }} onClick={IMGcompraInternacionalEbook} src={logoApple}></img>
                                            <a onClick={compraMexico} className='a-bit-opt' target='_blank' href='https://books.apple.com/us/audiobook/the-bitcoin-enlightenment-ending-the-fiat-dark-age/id1817382846'>Buy Ebook</a>
                                        </div>
                                        <div className='div-1'>
                                            <img onClick={IMGcompraInternacional} src={logo1}></img>
                                            <a onClick={compraInternacional} className='a-bit-opt' target='_blank' href='https://thesaifhouse.com/'>{(t('header.btn2'))}</a>
                                            <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-digital-book/?v=3d26b0b17065'>{(t('header.btn3'))}</a>
                                            <a onClick={compraInternacional} className='a-bit-opt-small' target='_blank' href='https://academy.saifedean.com/product/the-bitcoin-enlightenment-audiobook/?v=0b3b97fa6688'>
                                                Buy Audiobook
                                            </a>
                                        </div>


                                    </div>
                                </>
                            )}*/}
                        </div>
                        {/* 
                        <div class="adquierelo_content_2">
                            <div class="vertical-line"></div>
                        </div>
                        <div class="adquierelo_content_3">
                            
                        </div>
                        <img className='back-img-donde' src={librito}></img>*/}
                    </div>
                </div>
                {/* <div class="landing_bitcoin_donde_cintillo">
                    <h4>{(t('donde.cintillo'))}</h4>
                </div>*/}

            </div>



        </>
    )
}

export default Donde